document.addEventListener("DOMContentLoaded", function() {
  
  var submitButtons = document.querySelectorAll('form button[type="submit"], form input[type="submit"]');
  var numButtons = submitButtons.length;
  //console.log("OOOH! - Mannaggia il crocistrada, devo processare ", numButtons, " moduli!");
  
  submitButtons.forEach(function(button) {
      var form = button.closest('form');
      if (form) {
          var formId = form.id;
          var checkCnt = 0;
          var checkboxesWithDataConsPreference = form.querySelectorAll('input[data-cons-preference]');
          checkboxesWithDataConsPreference.forEach(function(checkbox) {
              checkCnt++;
          });
              
          button.addEventListener('click', function(event) {
              //console.log("OOOH! - Chiamo il maresciallo!!!!");
              
              if(checkCnt>=1 && form.checkValidity()){
                event.preventDefault();
                //console.log("OOOH! - Dormimoo?!!!!");
                
                if (typeof _iub !== 'undefined') {
                    //console.log("OOOH! - Vedi de ji affanculo!!!!");
                    var subjectId   = 'undefined';
                    var emailValue  = 'undefined';
                    var emailInputs = form.querySelectorAll('input[type="email"]');
                    emailInputs.forEach(function(emailInput) {
                        emailValue = emailInput.value;
                        subjectId = emailValue.toLowerCase().replace(/\W/g, '-');
                    });
                    //console.log("OOOH! - " + subjectId);
                    
                    // Synchronous call, it's sent right when this function is executed
                    _iub.cons_instructions.push(["submit", {
                        writeOnLocalStorage: false,
                        form: { 
                            selector: document.getElementById(formId),
                        },
                        consent: {
                            subject:{ id: subjectId, email: emailValue },
                            legal_notices: [
                                { identifier: 'privacy_policy', }
                            ],
                        }
                    },{
                        success: function(response) { 
                            //console.log("OOOH! - " + response);
                            form.submit();
                        }, 
                        error: function(response) { 
                            //console.log("OOOH! - " + response); 
                        }
                    }])
                } else {
                    //console.log("OOOH! - Vedi de ji affanculo!!!!");
                    form.submit();
                }
                
              } else {
                //console.log("OOOH! - MMannnnnaggia!!!!");
              }
          }) 
          
      }
  });

});